import GrIconsListComponent from './gr-icons-list';

export default GrIconsListComponent;